
import {empty as observableEmpty, throwError as observableThrowError,  Observable } from 'rxjs';

import {mergeMap, catchError} from 'rxjs/operators';
import { Component, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar,MatDialog } from '@angular/material';
import { LinkURLDirective } from 'vasat-ng';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { QMAP } from 'ng-qmap'
import { AppService } from '../commons/app.service';
import { TranslateService } from '@ngx-translate/core';
import {AppBaseComponent} from '../commons/AppBaseComponent';
import { FourDService } from '4d-mapper';

// generic helpers
import {Constants} from './../commons/Constants';
import { XsApplicationEventsService } from '../xs/services/events/application-events.service';
@Component({
    selector: 'profile-comp',
    templateUrl: './profile.component.html'
})
export class ProfileComponent extends AppBaseComponent{

    @ViewChild(LinkURLDirective,{static:false}) imageDirective
    error:string
    success:string
    fields:QMAP[] = []
    password = {}
    constructor(public fourD: FourDService, public service: AppService, public router: Router, public snackBar: MatSnackBar, public dialog: MatDialog, 
        public translate: TranslateService, applicationEvents:XsApplicationEventsService) {
        super(service, router, snackBar, dialog, applicationEvents);
    } 

    onReady() {
        
        var userMap = this.service.objectMetas.find(o => o.uid == 'User')

        this.translate.get(['PROFILE.NAME','PROFILE.EMAIL']).subscribe(r => {

            this.fields = this.service.siteSettings.userQMap || [{id:'name',title:r['PROFILE.NAME'],type:'shorttext'},
        {id:'email',type:'shorttext',title:r['PROFILE.EMAIL'],disabled:true}]

        })
        
        // hide HangOn / waiting box (if open)
        Constants.hideHangOn();
    }

    uploadFile(event) {
        this.loading = true
        let fileList: FileList = event.target.files
        if(fileList.length > 0) {
            let file: File = fileList[0]
            fetch(this.fourD.V.config.host + "/api/User/" + this.service.myProfile.id + '/image.png',{
                method: 'POST',
                body: file,
                headers:{
                    'Content-type':'application/binary',
                    Authorization:'bearer ' + this.service.V.authToken()
                }
            }
            ).then(r => { 
                this.loading = false
                // Reload the img src after file uplaoded to server
                this.imageDirective.updateLink()
            })
        
        }
        else{
            this.loading = false
        }
    }

    changeName() {
    
        this.loading = true
        this.service.myProfile.saveObservable().subscribe(
                res => {
                    var ls = this.fourD.V.localSession()
                    ls.user = this.service.myProfile
                    this.fourD.V.saveLocalSession(ls)
                    
                    this.loading = false
                    this.openSnackBarSuccess('PROFILE.UPDATED')
                },
                err => {
                    this.loading = false
                    this.openSnackBarError(this.error + ': ' + err.message)
                }
            )
    }
    pload:boolean
    setpass(){
       this.pload = true
       this.service.V.api('/api/me','put',this.password).subscribe(s => {
            this.pload = false
            this.openSnackBarSuccess('PROFILE.PASSWORD_SET')
            this.password = {}
       }
        ,
        e => {this.pload = false
            this.openSnackBarError(e.message)
        }
       )

    }
    
}